/**
 * Timeline module
 */
import {NgModule} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TimelineComponent} from '@ispm-client/modules/timeline/components/timeline.component';
import {TimelineEventFilterComponent} from '@ispm-client/modules/timeline/components/timeline-event-filter/timeline-event-filter.component';
import {SharedModule} from '@ispm/shared/shared.module';
import {TimelineEventInformationComponent} from '@ispm-client/modules/timeline/components/timeline-event-information/timeline.event.information.component';
import {CoreModule} from '@ispm/core/core.module';
import {DynamicFormModule} from '@ispm/dynamic-form/dynamic-form.module';
import {TimelineService} from "@ispm-client/modules/timeline/services/timeline.service";
import { PacsLauncherComponent } from '@ispm-client/modules/pacs-launcher/component/pacs-launcher.component';
import { PACSLauncherModule } from '../pacs-launcher/PACSLauncher.module';
import {WidgetsModule} from '@ispm/widgets/widgets.module';
import {AggregatorModule} from '@ispm-client/modules/aggregator/aggregator.module';
import {LayoutModule} from '@ispm/layout/layout.module';
import {AccordionModule} from 'primeng/accordion';
import {CheckboxModule} from 'primeng/checkbox';
import {FormsModule} from '@angular/forms';
import {FileModule} from '@ispm-client/modules/file-module/file.module';
import {TimeLineModule} from '@wuitk/angular/components/timeline';

@NgModule({
    imports: [
        TimeLineModule,        
        SharedModule,
        CoreModule,
        DynamicFormModule,
        WidgetsModule,
        AggregatorModule,
        LayoutModule,
        FileModule,
        AccordionModule,
        CheckboxModule,
        FormsModule,
        PACSLauncherModule,        
    ],
    declarations: [
        TimelineComponent,
        TimelineEventInformationComponent,
        TimelineEventFilterComponent,
    ],
    providers: [DatePipe, TimelineService],
    exports: [TimelineComponent, TimelineEventInformationComponent, TimelineEventFilterComponent],    
    entryComponents: [
      TimelineComponent,
      TimelineEventInformationComponent,
      TimelineEventFilterComponent,
      PacsLauncherComponent
    ]
})
export class TimelineModule {
}
